import { Component, Inject, OnInit } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../core/animations';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { Observable } from 'rxjs/Observable';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../const/date-format';
import { IndexCardConfigurationService } from '../../../../../services/index-card-configuration/index-card-configuration.service';
import { IndexCardConfiguration } from '../../../../../models/index-card-configuration/index-card-configuration';


@Component({
    selector: 'fuse-index-card-configuration',
    templateUrl: './index-card-configuration.component.html',
    styleUrls: ['./index-card-configuration.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class IndexCardConfigurationComponent implements OnInit {
    @BlockUI() blockUI: NgBlockUI;
    formGroup;
    widthFormControl;
    heightFormControl;
    marginTopFormControl;
    marginBottomFormControl;
    marginLeftFormControl;
    marginRightFormControl;
    rowHeighFormControl;


    public config = new IndexCardConfiguration();

    constructor(
        // @Inject(MAT_DIALOG_DATA) public data: any,
        // public dialogRef: MatDialogRef<IndexCardConfigurationComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        private indexCardConfigurationService: IndexCardConfigurationService
    ) {
        // console.log('FuseAddStudentComponent > data', data);
        this.initializeFormControlValidators();
    }


    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        Observable.combineLatest(
            this.indexCardConfigurationService.get()
        ).subscribe(([config]) => {
            this.config = config;
            console.log('this.config>>>>>>>>', this.config);
            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    initializeFormControlValidators() {
        this.formGroup = this.fb.group({
            widthFormControl: ['', [Validators.required]],
            heightFormControl: ['', [Validators.required]],
            marginTopFormControl: ['', [Validators.required]],
            marginBottomFormControl: ['', [Validators.required]],
            marginLeftFormControl: ['', [Validators.required]],
            marginRightFormControl: ['', [Validators.required]],
            rowHeighFormControl: ['', [Validators.required]],
        });
    }


    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    required(list) {
        return list.filter(e => e.Checked).length === 0;
    }

    save() {
        this.blockUI.start(this.translationService.savingChanges);
        this.indexCardConfigurationService.add(this.config).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                // this.dialogRef.close(this.config);
                this.translationService.translate('LABELS.SUCCESS_REQUEST', '', (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/configurations/index-card-configuration/index-card-configuration.component.ts